const forceString = (value) => (value ? `"=""${value.replaceAll('"', '""""')}"""` : '');
export const generateCsv = (columns, rows) => {
    const csv = [columns, ...rows.map((row) => row.map((cell) => (isNaN(cell) ? cell : forceString(cell))))]
        .map((columnOrRow) => columnOrRow.join(';'))
        .join('\r\n');
    return csv;
};
export default generateCsv;
